<template>
  <div class="week-by-car-stop">
    <div class="wrapper">
      <div style="font-weight: bold">周日均车辆加能站停靠统计</div>
      <WeekStatisticsTip style="margin-bottom: 20px;" />
      <div class="header">
        <el-form :inline="true" :model="formData" label-width="60px">
          <el-form-item label="省份">
            <el-select v-model="formData.provinceCode" placeholder="请选择活动区域">
              <el-option v-if="areaList.length>1" label="全部" value></el-option>
              <el-option v-for="(item,index) in areaList" :label="item.provinceName" :value="item.provinceCode"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统计周" label-width="75px">
            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>
          </el-form-item>
          <el-button style="margin-left:30px;" @click="onDebounceSearch">查询</el-button>
          <el-button style="margin-left:20px;" @click="showWeekDialog = true">导出</el-button>
          <WeekDialog @on-command="onWeekDialogCommand" v-if="showWeekDialog"/>
        </el-form>
      </div>
      <el-table ref="singleTable" :data="tableData" :max-height="tableHeight" stripe style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="50" fixed="left"/>
        <el-table-column prop="provinceName" label="省份" align="center" fixed>
          <template slot-scope="scope">
            <span v-if="scope.row.provinceName=='全国'">{{ scope.row.provinceName }}</span>
            <span v-else style="text-decoration: underline;color:rgba(24,83,137,1) "
                  @click="getCityDataVal(scope.row)">{{ scope.row.provinceName }}</span>
          </template>
        </el-table-column>
        <el-table-column v-for="(item1,index1) in tableCol" :label="item1.name" :key="index1" align="center">
          <el-table-column v-for="(item2,index2) in item1.children" :label="item2.name" :key="index2" align="center"
                           min-width="150">
            <el-table-column v-if="curDate" align="center" :min-width="160">
              <template slot="header" slot-scope="scope">
                <div style="line-height: initial;padding:initial ">{{ curDate }}</div>
                <div style="line-height: initial;padding:initial ">({{ curDateRange }})</div>
              </template>
              <template slot-scope="scope">{{ scope.row[item2.prop] || 0 }}</template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="bottom-top">
      <h4>
        <img src="../../../assets/images/title.png">
        <span>说明</span>
      </h4>
      <div>
        1.统计逻辑：统计不同燃料类型车辆在各运营省内不同品牌的7天日均加能站停靠车次数。【注】一辆车在同个加能站一天停靠多次计为一次；停靠统计时长范围为3分钟-2小时。
      </div>
      <div>
        2.统计频率：按周统计，每周日更新上周日至本周六数据。
      </div>
      <div>
        3.下一级页面：点击具体省份名称，可进入该省下各市周日均车辆加能站停靠统计页面。
      </div>
    </div>
  </div>
</template>
<script>
import http from '@/api/freight.js' //请求汇总
import _ from 'lodash'
import WeekPopover from '../weekByCarNum/components/weekPopover.vue'
import WeekDialog from '../weekByCarNum/components/weekDialog.vue'
import areaList from '../weekByCarNum/components/areaList'
import WeekStatisticsTip from "@/components/WeekStatisticsTip.vue";

export default {
  name: 'week-by-car-stop',
  components: {WeekPopover, WeekDialog, WeekStatisticsTip},
  data() {
    return {
      showWeekDialog: false,

      formData: {
        provinceCode: '',
      },

      tableCol: [
        {
          name: '合计',
          children: [
            {name: '全部车辆', prop: 'stopAll0'},
            {name: '柴油车辆', prop: 'stopAll1'},
            {name: 'LNG车辆', prop: 'stopAll2'},
            {name: '新能源车辆', prop: 'stopAll3'},
          ],
        },
        {
          name: 'S级油站',
          children: [
            {name: '全部车辆', prop: 'stopS0'},
            {name: '柴油车辆', prop: 'stopS1'},
            {name: 'LNG车辆', prop: 'stopS2'},
            {name: '电车辆', prop: 'stopS3'},
            {name: '氢车辆', prop: 'stopS4'},
            {name: '其他车辆', prop: 'stopS5'},
          ],
        },
        {
          name: 'C级油站',
          children: [
            {name: '全部车辆', prop: 'stopC0'},
            {name: '柴油车辆', prop: 'stopC1'},
            {name: 'LNG车辆', prop: 'stopC2'},
            {name: '电车辆', prop: 'stopC3'},
            {name: '氢车辆', prop: 'stopC4'},
            {name: '其他车辆', prop: 'stopC5'},
          ],
        },
        {
          name: 'E级油站',
          children: [
            {name: '全部车辆', prop: 'stopE0'},
            {name: '柴油车辆', prop: 'stopE1'},
            {name: 'LNG车辆', prop: 'stopE2'},
            {name: '电车辆', prop: 'stopE3'},
            {name: '氢车辆', prop: 'stopE4'},
            {name: '其他车辆', prop: 'stopE5'},
          ],
        },
      ],

      curDate: '',
      curDateRange: '',

      tableData: [],

      onDebounceSearch: _.debounce(this.getData, 500),
    }
  },
  computed: {
    areaList() {
      let nerArr = JSON.parse(JSON.stringify(this.$store.getters.areaList))
      if (nerArr.length > 0) {
        nerArr.forEach(item => {
          item.provinceCode = item.provinceCode + '0000'
        })
      }
      return nerArr
    },
  },
  methods: {
    getCityDataVal(row) {
      let curSelectedWeek = this.$refs['weekPopoverRef'].curSelectedWeek
      this.$router.push({
        path: 'weeklyBrandGasSen',
        query: {
          cityCode: row.provinceCode,
          cityName: row.provinceName,
          ...curSelectedWeek
        }
      })
    },
    getData() {
      let curSelectedWeek = this.$refs['weekPopoverRef'].curSelectedWeek
      if (!curSelectedWeek) {
        this.$message({
          message: '请选择周',
          type: 'warning',
        })
        return
      }

      this.tableData = []
      http
          .getWeekBrandStop({...this.formData, ...curSelectedWeek, type: 1})
          .then((e) => {
            if (200 != e.code) {
              this.$message({
                message: e.message || '数据获取出错',
                type: 'error',
              })
              return
            }
            if (e.data.length == 0) {
              this.tableData = []
              return;
            }
            let tmpData = e.data || []
            let tmpDataByProvinceCode = {}
            this.curDate = `${curSelectedWeek.year}年${curSelectedWeek.month}月第${curSelectedWeek.week}周`
            this.curDateRange = e.data[0].weekStart + '-' + e.data[0].weekEnd
            tmpData.forEach((_) => {
              if ('all' === _.areaCode) {
                _.areaCode = 0
              }
              // let existProvince = [
              //   {provinceCode: 0, provinceName: '全国'},
              //   ...this.areaList,
              // ].find((__) => __.provinceCode == _.areaCode)
              // if (existProvince) {
                if (!tmpDataByProvinceCode.hasOwnProperty(_.areaCode)) {
                  tmpDataByProvinceCode[_.areaCode] = {
                    provinceName: _.provinceName,
                    provinceCode: _.areaCode,
                  }
                }
                tmpDataByProvinceCode[_.areaCode] = {
                  ...tmpDataByProvinceCode[_.areaCode],
                  [`stopS${_.fuelType}`]: _.stopS,
                  [`stopC${_.fuelType}`]: _.stopC,
                  [`stopE${_.fuelType}`]: _.stopE,
                  [`stopAll${_.fuelType}`]: _.stopS + _.stopC + _.stopE,
                }
              // }
            })

            this.tableData = Object.values(tmpDataByProvinceCode).sort(
                (a, b) => b['stopAll0'] - a['stopAll0']
            )
          })
          .catch((err) => {
            console.error(err)
            this.curDate = ''
          })
    },

    onWeekPopOverCommand(params) {
      switch (params.type) {
        case 'default-week':
          this.getData()
          break
        default:
          break
      }
    },

    onWeekDialogCommand(params) {
      switch (params.type) {
        case 'ok':
          window.location.assign(http.getWeekBrandStopExport({
            ...params.data,
            ...this.formData, type: 1
          }))
          this.showWeekDialog = false
          break
        case 'close':
          this.showWeekDialog = false
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
span, .font20 {cursor: pointer;}
.wrapper {
  padding: 20px;
  background: #fff;
}
</style>
